import React, { useContext } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { MobileContext } from '../../domain/context/MobileContext';

import { getDescription } from '../../domain/state/metadata/selectors';

interface StateProps {
  description: string;
}

const mapStateToProps = (state) => ({
  description: getDescription(state),
});

interface OwnProps {
  className?: string;
}

export const PageDescription = connect<StateProps, TPseudoObject, OwnProps>(
  mapStateToProps,
)((props: StateProps & OwnProps) => {
  const { className, description } = props;
  const isMobile = useContext(MobileContext);
  return description ? (
    <StyledDescription
      isMobile={isMobile}
      className={className}
      dangerouslySetInnerHTML={{ __html: description }}
    />
  ) : null;
});

const StyledDescription = styled.div<{ isMobile: boolean }>`
  margin-bottom: 16px;
  min-width: 700px;
  font-size: 16px;
  line-height: 20px;

  ${({ isMobile }) =>
    isMobile && 'font-size: 14px; line-height: 16px; min-width: 100%;'}

  /* Перекрываем global reset.css из легаси сборки, после релиза оптимизации можно удалить */
  ul {
    padding-inline-start: 40px;
    margin-block-start: 1em;
    margin-block-end: 1em;
    list-style-type: disc;
  }

  p {
    margin-block-start: 1em;
    margin-block-end: 1em;
  }

  h2 {
    font-size: 1.5em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    font-weight: bold;
  }
`;
